module.exports = "/_next/static/images/ourPartnersAstoundLogo-68505680bcc0cac4e0846a708a113130.webp";